
export enum AppView {
  App = 'APP',
  Widget = 'WIDGET'
}
